import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { submitClassificationReview } from '../requests/registrationReview.request';
import {
  ClassificationReviewRequest,
  ClassificationReviewResult
} from '../types/registrationReview.types';

export const useClassificationReviewMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ClassificationReviewResult | undefined,
    AxiosError,
    { plateId: string; clientId: string; request: ClassificationReviewRequest }
  >({
    mutationKey: ['classification-review'],
    mutationFn: ({ plateId, request }) => submitClassificationReview(plateId, request),
    onSuccess: (_data, variables) => {
      // The carousel removes the item locally; this keeps the plate grid fresh.
      queryClient.invalidateQueries({
        queryKey: ['plate-registration-summary', variables.clientId]
      });
    }
  });
};
